// extracted by mini-css-extract-plugin
module.exports = {"viewMailArt":"IndexMailArt-module--viewMailArt--3-yYO","item":"IndexMailArt-module--item--37OgI"};